import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { hexToRgba } from '~utils/utilFunctions';

interface NoDataAlertProps {
  message: string;
  sx?: SxProps<Theme>;
}

export default function NoDataAlert({ message, sx }: NoDataAlertProps) {
  return (
    <Box
      sx={[
        (theme) => ({
          alignItems: 'center',
          bgcolor: hexToRgba(theme.brandV2.colors.treadOrangeDark, 0.1),
          borderRadius: theme.brandV2.borderRadius,
          display: 'flex',
          gap: 0.75,
          justifyContent: 'center',
          p: 1,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <InfoOutlined
        sx={(theme) => ({
          color: theme.brandV2.colors.treadOrangeDark,
          fontSize: '18px',
        })}
      />

      <Typography
        variant="body2"
        sx={(theme) => ({ color: theme.brandV2.colors.treadOrangeDark })}
      >
        {message}
      </Typography>
    </Box>
  );
}
